import { render, staticRenderFns } from "./GoodsList.vue?vue&type=template&id=1b8d0334&scoped=true&lang=html"
import script from "./GoodsList.vue?vue&type=script&lang=js"
export * from "./GoodsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8d0334",
  null
  
)

export default component.exports